import classes from "./TaskItem.module.css";

// <li className={classes.task}>{props.children}</li>;
const TaskItem = (props) => {
  function ConvertDateStringToDate(strDate, type) {
    function addZero(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    }

    const d = new Date(strDate);
    const dag = d.toLocaleString("nl-NL", { day: "2-digit" });
    const maand = d.toLocaleString("nl-NL", { month: "2-digit" });
    const jaar = d.getFullYear();
    const datum = dag + "-" + maand + "-" + jaar;

    const uur = addZero(d.getHours());
    const minuut = addZero(d.getMinutes());
    const seconde = addZero(d.getSeconds());
    const tijd = uur + ":" + minuut + ":" + seconde;

    switch (type) {
      case "date":
        return datum;
      //break;
      case "time":
        return tijd;
      //break;
      default:
        return datum + " " + tijd;
    }
  }

  return (
    <tr className={classes.task}>
      <td>{props.taak}</td>
      <td>{props.status}</td>
      <td>{ConvertDateStringToDate(props.begindatum, "date")}</td>
      <td>{ConvertDateStringToDate(props.einddatum, "date")}</td>
    </tr>
  );
};

export default TaskItem;